export default {
  header: 'Welcome to Psytest - Psychological testing online!',
  header_lisberg:
    'Welcome to the Lisberg web system for psychological testing!',
  content:
    '<p>As a registered user you can let candidates take our tests and print the results. <br/>The same tests can also be sent by e-mail and answered from the candidate\'s home environment. <p>You can read more about the tests at <a href="http://www.psytest.se" target="_blank">www.psytest.se</a></p>',
  content_lisberg:
    '<p>As a registered user you can let candidates take our tests and print the results. <br/>The same tests can also be sent by e-mail and answered from the candidate\'s home environment. <p>You can read more about the tests at <a href="http://www.lisberg.se" target="_blank">www.lisberg.se</a></p>',
  menu: 'Startpage'
}
